import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { guideItems } from "@/mocks/content";

export default function WatchGuide() {
  const [openId, setOpenId] = useState<string>(guideItems[0].id);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
        <div className="lg:col-span-5">
          <SectionHeading
            id="guide"
            eyebrow="Viewing Guide"
            title="观影与选片指南"
            description="选片不只是看热度。把类型、片长、地区风格与系列关系综合考虑，能明显减少「点开又关掉」的情况。下面是几条实用的判断思路。"
          />
          <div className="mt-8 rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center gap-2 text-sm font-medium text-foreground-900">
              <i className="ri-bookmark-3-line text-accent-500"></i>
              使用建议
            </div>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              可以先在「最新电影」区用筛选缩小范围，再到「热播剧集」或「欧美大片」区交叉对照，
              最后结合自己的可支配时间决定看什么。
            </p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-lg border border-background-200 overflow-hidden bg-background-50">
            {guideItems.map((item) => {
              const open = openId === item.id;
              return (
                <div key={item.id} className="border-b border-background-200 last:border-b-0">
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? "" : item.id)}
                    aria-expanded={open}
                    className="w-full flex items-center gap-4 p-5 text-left cursor-pointer hover:bg-primary-50 transition-colors"
                  >
                    <span
                      className={`w-10 h-10 shrink-0 rounded-md flex items-center justify-center transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-primary-100 text-primary-700"
                      }`}
                    >
                      <i className={`${item.icon} text-lg`}></i>
                    </span>
                    <span className="flex-1 font-heading text-base font-semibold text-foreground-950">
                      {item.title}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform duration-300 ${
                        open ? "rotate-180" : ""
                      }`}
                    ></i>
                  </button>
                  <div className={open ? "px-5 pb-5 pl-[76px]" : "hidden px-5 pb-5 pl-[76px]"}>
                    <p className="text-sm leading-7 text-foreground-600">{item.detail}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}